import React, { Fragment } from "react";

const ZbiorowyWydrukTHead = props => {

    const { listaMsc, visible, rok, czyRok } = props;

    const kolumnyMiesiace = listaMsc?.map( (e, i) => {
        return (
            <Fragment key={i}>
                <td style={{border: "1px solid black", padding: "1px 2px"}}>
                    należności
                </td>
                <td style={{border: "1px solid black", padding: "1px 2px"}}>
                    wpłaty
                </td>
                <td style={{border: "1px solid black", padding: "1px 2px"}}>
                    saldo
                </td>
            </Fragment>
        )

    })
    
    const thDaty = listaMsc?.map( (e,i) => {
        return (
            <th 
                colSpan={3} 
                style={{textAlign: "center", border: "1px solid black"}}
                key={i}
            >
                {e}
            </th>
        )
    })

    const thRok = czyRok && (<th style={{textAlign: "center", border: "1px solid black"}}>{`Na koniec ${rok}`}</th>); 
    const thRokCols = czyRok && (<Fragment>
        <th style={{textAlign: "center", border: "1px solid black"}}>razem</th>
    </Fragment>)


    return (
        <thead>
            <tr key={-1}>
                <th rowSpan={2} style={{border: "1px solid black"}}>
                    Mieszkaniec
                </th>
                <th rowSpan={2} style={{border: "1px solid black"}}>
                    Adres
                </th>
                {
                    <Fragment>
                        {thRok}
                        {
                            visible ? (
                                <Fragment>{thDaty}</Fragment> ) : (<Fragment></Fragment>) 

                        }
                        <th colSpan={3} style={{textAlign: "center", border: "1px solid black"}}>
                            Podsumowanie
                        </th>
                    </Fragment>
                }
            </tr>
            {
                <tr key={0}>
                    {thRokCols}
                    {
                        visible ? (kolumnyMiesiace) : <Fragment></Fragment>
                    }
                    <td style={{border: "1px solid black"}}>
                        nal. razem
                    </td>
                    <td style={{border: "1px solid black"}}>
                        wpł. razem
                    </td>
                    <td style={{border: "1px solid black"}}>
                        sal. razem
                    </td>
                </tr>
            }
        </thead>
    )
}

export default ZbiorowyWydrukTHead;